import React, { useState, useEffect } from 'react'
import Table from './Table'
import styled, { css } from 'styled-components'
import { CSSTransition } from 'react-transition-group'

function SectionDrop({
  disabled,
  children,
  products,
  title,
  description,
  filters,
  cart,
  handleCart,
  id,
  withThoTable,
  hideTable,
}) {
  const [isVisibleModal, setIsVisibleModal] = useState(false)
  const [isVisibleFirstTable, setIsVisibleFirstTable] = useState(true)
  const [isVisibleSecondTable, setIsVisibleSecondTable] = useState(false)

  useEffect(() => {
    if (cart.length != 0 && cart.some(el => el.category_id === id)) setIsVisibleSecondTable(true)
  }, [cart])

  const [active, setActive] = useState(false)

  const showSection = () => {
    setActive(!active)
  }

  return (
    <Wrap active={active} disabled={disabled}>
      <HelperInfo onClick={() => setIsVisibleModal(true)}>
        <div className="helpers">?</div>
      </HelperInfo>
      <Top onClick={showSection}>
        {title && <Title>{title}</Title>}
        <ViewStateSection active={active} />
      </Top>
      {active && (
        <TableWrap>
          {children && <WrapChildren>{children}</WrapChildren>}
          {!hideTable &&
            (withThoTable ? (
              <>
                <ShowTable
                  showTable={isVisibleFirstTable}
                  onClick={() => setIsVisibleFirstTable(!isVisibleFirstTable)}
                >
                  <ViewStateSection tiltType active={isVisibleFirstTable} />
                  {id == 7 ? 'Декоративные минеральные штукатурки' : 'Клеевой армирующий состав'}
                </ShowTable>
                {isVisibleFirstTable && (
                  <Table
                    products={products.filter(product => product.section == 1)}
                    filters={filters}
                    cart={cart}
                    handleCart={handleCart}
                    categoryId={id}
                    subCategory={1}
                  />
                )}

                <ShowTable
                  showTable={isVisibleSecondTable}
                  onClick={() => setIsVisibleSecondTable(!isVisibleSecondTable)}
                >
                  <ViewStateSection tiltType active={isVisibleSecondTable} />
                  {id == 7 ? 'Фасадная краска' : 'Стеклоседка фасадная'}
                </ShowTable>
                {isVisibleSecondTable && (
                  <Table
                    products={products.filter(product => product.section == 2)}
                    filters={filters}
                    cart={cart}
                    handleCart={handleCart}
                    categoryId={id}
                    subCategory={2}
                  />
                )}
              </>
            ) : (
              <Table
                products={products}
                filters={filters}
                cart={cart}
                handleCart={handleCart}
                categoryId={id}
              />
            ))}
        </TableWrap>
      )}
      <CSSTransition
        in={isVisibleModal}
        timeout={700}
        onClose={() => setIsVisibleModal(false)}
        classNames="modal"
        unmountOnExit
      >
        <S.Modal>
          <S.BgLayout onClick={() => setIsVisibleModal(false)} />
          <S.ModalPanel>
            <S.ModalCloseIcon onClick={() => setIsVisibleModal(false)}>&#215;</S.ModalCloseIcon>
            <S.PanelWrap>
              <S.TitleModal>{title}</S.TitleModal>
              <S.ModalData className="content" dangerouslySetInnerHTML={{ __html: description }} />
            </S.PanelWrap>
          </S.ModalPanel>
        </S.Modal>
      </CSSTransition>
    </Wrap>
  )
}

export default SectionDrop

const Wrap = styled.div`
  background: #f2f2f2;
  border: 1px solid #f2f2f2;
  border-radius: 3px;
  position: relative;

  @media (max-width: 1024px) {
    margin-right: 30px;
  }

  ${p =>
    p.active &&
    css`
      border-color: #fbdf83;
    `}

  ${p =>
    p.disabled &&
    css`
      opacity: 0.2;
      pointer-events: none;
    `}
`
const WrapChildren = styled.div`
  background: #fff;
  padding: 20px 14px;
`
const Top = styled.div`
  position: relative;
  padding: 12px 50px 12px 14px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    opacity: 0.8;
  }
`
const Title = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
`
const TableWrap = styled.div``
const ViewStateSection = styled.div`
  position: absolute;
  right: 20px;
  top: 18px;
  width: 11px;
  height: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:after,
  &:before {
    content: '';
    background: #3e444a;
    width: 100%;
    height: 3px;
    transition: .3s;
  }

  &:after {
    height: 100%;
    width: 3px;
    position: absolute;
    left: 0;
    top 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  
  ${p =>
    p.active &&
    css`
      &:after {
        height: 0;
      }
    `}
  
  ${p =>
    p.tiltType &&
    css`
      left: 14px;
      top: 24px;
    `}
`
const HelperInfo = styled.div`
  position: absolute;
  right: -30px;
  top: 10px;
  cursor: pointer;

  @media (max-width: 1024px) {
  }

  .helpers {
    width: 22px;
    height: 22px;
    font-size: 14px;
    line-height: 20px;
  }
`
const S = styled.div``
S.ModalPanel = styled.div`
  width: 100%;
  // height: 100%;
  max-width: 505px;
  min-height: 200px;
  background: #fff;
  padding: 30px 25px;
  overflow-x: hidden;
  max-height: 100%;
  position: relative;
  z-index: 52;
  transition: 0.3s;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.0882867);
  border-radius: 5px;

  @media (max-width: 767px) {
    padding: 30px 20px;
  }
`
S.Modal = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: visible;
  opacity: 1;
  pointer-events: auto;
  z-index: 50;
  padding: 25px;

  @media (max-width: 767px) {
    padding: 30px 20px;
  }

  &.modal-enter {
    opacity: 0;
    transform: scale(1.5);
  }
  &.modal-enter-active {
    opacity: 1;
    transform: translateX(0);
    transition: opacity 700ms, transform 700ms;
  }
  &.modal-exit {
    opacity: 1;
  }
  &.modal-exit-active {
    opacity: 0;
    transform: scale(1.5);
    transition: opacity 700ms, transform 700ms;

    ${S.ModalPanel} {
      transform: scale(0.4);
      opacity: 0;
    }
  }
`

S.ModalCloseIcon = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  padding: 15px;
  cursor: pointer;
  transition: 0.3s;
  font-size: 45px;
  font-weight: 700;
  color: #3e444a;

  &:hover {
    opacity: 0.8;
    transform: scale(0.9);
  }
`
S.BgLayout = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 35px 20px;
  z-index: 51;
  // background: rgba(21, 22, 30, 0.65);
  backdrop-filter: blur(4px);
`
S.TitleModal = styled.div`
  font-size: 22px;
  font-weight: 700;
  padding-bottom: 20px;
`
S.ModalData = styled.div`
  height: 100%;
  font-size: 14px;

  p {
    margin: 0;
    padding-bottom: 15px;
  }

  & > * {
    padding-bottom: 0;
  }

  b,
  strong {
    font-weight: 700;
  }

  i,
  em {
    font-style: italic;
  }

  a {
    color: #3a4145;
    text-decoration: underline;
    font-weight: 500;
    transition: 0.3s;

    &:hover {
      opacity: 0.8;
      text-decoration: underline;
    }
  }
`
S.PanelWrap = styled.div`
  height: 100%;
`
const ShowTable = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 19px;
  color: #333333;
  background: #fff;
  padding: 20px 14px 0 34px;
  position: relative;
  cursor: pointer;

  &:last-child {
    padding-bottom: 30px;
  }

  &:hover {
    color: #8c8c8c;
  }

  ${p =>
    p.showTable &&
    css`
      padding-bottom: 0;
    `}
`
